// Comprehensive country to timezone mapping for auto-detection

interface TimezoneInfo {
  offset: string;
  label: string;
}

// Map countries to their primary timezone (using the most common/capital city timezone)
const countryTimezones: Record<string, TimezoneInfo> = {
  // Africa
  'Kenya': { offset: 'UTC+3', label: 'UTC+3 (East Africa Time)' },
  'Tanzania': { offset: 'UTC+3', label: 'UTC+3 (East Africa Time)' },
  'Uganda': { offset: 'UTC+3', label: 'UTC+3 (East Africa Time)' },
  'Rwanda': { offset: 'UTC+2', label: 'UTC+2 (Central Africa Time)' },
  'Ethiopia': { offset: 'UTC+3', label: 'UTC+3 (East Africa Time)' },
  'Nigeria': { offset: 'UTC+1', label: 'UTC+1 (West Africa Time)' },
  'Ghana': { offset: 'UTC+0', label: 'UTC+0 (Ghana Time)' },
  'Senegal': { offset: 'UTC+0', label: 'UTC+0 (Greenwich Mean Time)' },
  "Côte d'Ivoire": { offset: 'UTC+0', label: 'UTC+0 (Greenwich Mean Time)' },
  'Mali': { offset: 'UTC+0', label: 'UTC+0 (Greenwich Mean Time)' },
  'Burkina Faso': { offset: 'UTC+0', label: 'UTC+0 (Greenwich Mean Time)' },
  'South Africa': { offset: 'UTC+2', label: 'UTC+2 (South Africa Time)' },
  'Egypt': { offset: 'UTC+2', label: 'UTC+2 (Egypt Time)' },
  'Morocco': { offset: 'UTC+1', label: 'UTC+1 (Morocco Time)' },
  'Tunisia': { offset: 'UTC+1', label: 'UTC+1 (Central European Time)' },
  'Algeria': { offset: 'UTC+1', label: 'UTC+1 (Central European Time)' },
  'Namibia': { offset: 'UTC+2', label: 'UTC+2 (Central Africa Time)' },
  'Botswana': { offset: 'UTC+2', label: 'UTC+2 (Central Africa Time)' },
  'Zimbabwe': { offset: 'UTC+2', label: 'UTC+2 (Central Africa Time)' },
  'Zambia': { offset: 'UTC+2', label: 'UTC+2 (Central Africa Time)' },
  'Mozambique': { offset: 'UTC+2', label: 'UTC+2 (Central Africa Time)' },
  'Madagascar': { offset: 'UTC+3', label: 'UTC+3 (East Africa Time)' },
  'Mauritius': { offset: 'UTC+4', label: 'UTC+4 (Mauritius Time)' },
  'Seychelles': { offset: 'UTC+4', label: 'UTC+4 (Seychelles Time)' },

  // Europe
  'United Kingdom': { offset: 'UTC+0', label: 'UTC+0 (London, Dublin)' },
  'UK': { offset: 'UTC+0', label: 'UTC+0 (London, Dublin)' },
  'Ireland': { offset: 'UTC+0', label: 'UTC+0 (London, Dublin)' },
  'Portugal': { offset: 'UTC+0', label: 'UTC+0 (Lisbon)' },
  'Iceland': { offset: 'UTC+0', label: 'UTC+0 (Reykjavik)' },
  'France': { offset: 'UTC+1', label: 'UTC+1 (Paris, Berlin, Rome)' },
  'Germany': { offset: 'UTC+1', label: 'UTC+1 (Paris, Berlin, Rome)' },
  'Italy': { offset: 'UTC+1', label: 'UTC+1 (Paris, Berlin, Rome)' },
  'Spain': { offset: 'UTC+1', label: 'UTC+1 (Madrid)' },
  'Netherlands': { offset: 'UTC+1', label: 'UTC+1 (Amsterdam)' },
  'Belgium': { offset: 'UTC+1', label: 'UTC+1 (Brussels)' },
  'Switzerland': { offset: 'UTC+1', label: 'UTC+1 (Zurich)' },
  'Austria': { offset: 'UTC+1', label: 'UTC+1 (Vienna)' },
  'Poland': { offset: 'UTC+1', label: 'UTC+1 (Warsaw)' },
  'Czech Republic': { offset: 'UTC+1', label: 'UTC+1 (Prague)' },
  'Czechia': { offset: 'UTC+1', label: 'UTC+1 (Prague)' },
  'Hungary': { offset: 'UTC+1', label: 'UTC+1 (Budapest)' },
  'Denmark': { offset: 'UTC+1', label: 'UTC+1 (Copenhagen)' },
  'Sweden': { offset: 'UTC+1', label: 'UTC+1 (Stockholm)' },
  'Norway': { offset: 'UTC+1', label: 'UTC+1 (Oslo)' },
  'Croatia': { offset: 'UTC+1', label: 'UTC+1 (Zagreb)' },
  'Slovenia': { offset: 'UTC+1', label: 'UTC+1 (Ljubljana)' },
  'Slovakia': { offset: 'UTC+1', label: 'UTC+1 (Bratislava)' },
  'Luxembourg': { offset: 'UTC+1', label: 'UTC+1 (Luxembourg)' },
  'Monaco': { offset: 'UTC+1', label: 'UTC+1 (Monaco)' },
  'Malta': { offset: 'UTC+1', label: 'UTC+1 (Malta)' },
  'Greece': { offset: 'UTC+2', label: 'UTC+2 (Athens)' },
  'Finland': { offset: 'UTC+2', label: 'UTC+2 (Helsinki)' },
  'Romania': { offset: 'UTC+2', label: 'UTC+2 (Bucharest)' },
  'Bulgaria': { offset: 'UTC+2', label: 'UTC+2 (Sofia)' },
  'Turkey': { offset: 'UTC+3', label: 'UTC+3 (Istanbul)' },
  'Ukraine': { offset: 'UTC+2', label: 'UTC+2 (Kyiv)' },
  'Russia': { offset: 'UTC+3', label: 'UTC+3 (Moscow)' },
  'Cyprus': { offset: 'UTC+2', label: 'UTC+2 (Nicosia)' },
  'Estonia': { offset: 'UTC+2', label: 'UTC+2 (Tallinn)' },
  'Latvia': { offset: 'UTC+2', label: 'UTC+2 (Riga)' },
  'Lithuania': { offset: 'UTC+2', label: 'UTC+2 (Vilnius)' },
  'Serbia': { offset: 'UTC+1', label: 'UTC+1 (Belgrade)' },
  'Montenegro': { offset: 'UTC+1', label: 'UTC+1 (Podgorica)' },
  'Bosnia and Herzegovina': { offset: 'UTC+1', label: 'UTC+1 (Sarajevo)' },
  'North Macedonia': { offset: 'UTC+1', label: 'UTC+1 (Skopje)' },
  'Albania': { offset: 'UTC+1', label: 'UTC+1 (Tirana)' },
  'Kosovo': { offset: 'UTC+1', label: 'UTC+1 (Pristina)' },

  // Asia
  'Japan': { offset: 'UTC+9', label: 'UTC+9 (Japan, South Korea)' },
  'South Korea': { offset: 'UTC+9', label: 'UTC+9 (Japan, South Korea)' },
  'China': { offset: 'UTC+8', label: 'UTC+8 (China, Singapore, Malaysia)' },
  'Taiwan': { offset: 'UTC+8', label: 'UTC+8 (Taipei)' },
  'Hong Kong': { offset: 'UTC+8', label: 'UTC+8 (Hong Kong)' },
  'Macau': { offset: 'UTC+8', label: 'UTC+8 (Macau)' },
  'Singapore': { offset: 'UTC+8', label: 'UTC+8 (China, Singapore, Malaysia)' },
  'Malaysia': { offset: 'UTC+8', label: 'UTC+8 (China, Singapore, Malaysia)' },
  'Indonesia': { offset: 'UTC+7', label: 'UTC+7 (Jakarta)' },
  'Philippines': { offset: 'UTC+8', label: 'UTC+8 (Manila)' },
  'Thailand': { offset: 'UTC+7', label: 'UTC+7 (Thailand, Vietnam)' },
  'Vietnam': { offset: 'UTC+7', label: 'UTC+7 (Thailand, Vietnam)' },
  'Cambodia': { offset: 'UTC+7', label: 'UTC+7 (Indochina Time)' },
  'Laos': { offset: 'UTC+7', label: 'UTC+7 (Indochina Time)' },
  'Myanmar': { offset: 'UTC+6:30', label: 'UTC+6:30 (Myanmar Time)' },
  'India': { offset: 'UTC+5:30', label: 'UTC+5:30 (India, Sri Lanka)' },
  'Sri Lanka': { offset: 'UTC+5:30', label: 'UTC+5:30 (India, Sri Lanka)' },
  'Nepal': { offset: 'UTC+5:45', label: 'UTC+5:45 (Nepal Time)' },
  'Bangladesh': { offset: 'UTC+6', label: 'UTC+6 (Bangladesh, Kazakhstan)' },
  'Pakistan': { offset: 'UTC+5', label: 'UTC+5 (Pakistan, Uzbekistan)' },
  'Afghanistan': { offset: 'UTC+4:30', label: 'UTC+4:30 (Afghanistan Time)' },
  'Iran': { offset: 'UTC+3:30', label: 'UTC+3:30 (Iran Time)' },
  'Iraq': { offset: 'UTC+3', label: 'UTC+3 (Baghdad)' },
  'Saudi Arabia': { offset: 'UTC+3', label: 'UTC+3 (Arabia Time)' },
  'United Arab Emirates': { offset: 'UTC+4', label: 'UTC+4 (Dubai, Baku)' },
  'UAE': { offset: 'UTC+4', label: 'UTC+4 (Dubai, Baku)' },
  'Qatar': { offset: 'UTC+3', label: 'UTC+3 (Qatar Time)' },
  'Bahrain': { offset: 'UTC+3', label: 'UTC+3 (Arabia Time)' },
  'Kuwait': { offset: 'UTC+3', label: 'UTC+3 (Arabia Time)' },
  'Oman': { offset: 'UTC+4', label: 'UTC+4 (Gulf Time)' },
  'Jordan': { offset: 'UTC+3', label: 'UTC+3 (Jordan Time)' },
  'Lebanon': { offset: 'UTC+2', label: 'UTC+2 (Eastern European Time)' },
  'Israel': { offset: 'UTC+2', label: 'UTC+2 (Israel Time)' },
  'Palestine': { offset: 'UTC+2', label: 'UTC+2 (Palestine Time)' },
  'Maldives': { offset: 'UTC+5', label: 'UTC+5 (Maldives Time)' },
  'Bhutan': { offset: 'UTC+6', label: 'UTC+6 (Bhutan Time)' },
  'Mongolia': { offset: 'UTC+8', label: 'UTC+8 (Ulaanbaatar)' },
  'Kazakhstan': { offset: 'UTC+6', label: 'UTC+6 (Almaty)' },
  'Uzbekistan': { offset: 'UTC+5', label: 'UTC+5 (Pakistan, Uzbekistan)' },
  'Turkmenistan': { offset: 'UTC+5', label: 'UTC+5 (Turkmenistan Time)' },
  'Tajikistan': { offset: 'UTC+5', label: 'UTC+5 (Tajikistan Time)' },
  'Kyrgyzstan': { offset: 'UTC+6', label: 'UTC+6 (Bishkek Time)' },
  'Azerbaijan': { offset: 'UTC+4', label: 'UTC+4 (Dubai, Baku)' },
  'Georgia': { offset: 'UTC+4', label: 'UTC+4 (Tbilisi)' },
  'Armenia': { offset: 'UTC+4', label: 'UTC+4 (Yerevan)' },

  // Oceania
  'Australia': { offset: 'UTC+10', label: 'UTC+10 (Australia East)' },
  'New Zealand': { offset: 'UTC+12', label: 'UTC+12 (New Zealand)' },
  'Fiji': { offset: 'UTC+12', label: 'UTC+12 (Fiji Time)' },
  'Papua New Guinea': { offset: 'UTC+10', label: 'UTC+10 (Port Moresby)' },
  'New Caledonia': { offset: 'UTC+11', label: 'UTC+11 (New Caledonia)' },
  'French Polynesia': { offset: 'UTC-10', label: 'UTC-10 (Tahiti)' },
  'Samoa': { offset: 'UTC+13', label: 'UTC+13 (Samoa Time)' },
  'Tonga': { offset: 'UTC+13', label: 'UTC+13 (Tonga Time)' },
  'Vanuatu': { offset: 'UTC+11', label: 'UTC+11 (Vanuatu)' },
  'Solomon Islands': { offset: 'UTC+11', label: 'UTC+11 (Solomon Islands)' },
  'Guam': { offset: 'UTC+10', label: 'UTC+10 (Chamorro Time)' },

  // North America
  'United States': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'USA': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'US': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Canada': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Mexico': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },

  // Central America & Caribbean
  'Guatemala': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'Belize': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'Honduras': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'El Salvador': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'Nicaragua': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'Costa Rica': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'Panama': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Cuba': { offset: 'UTC-5', label: 'UTC-5 (Cuba Time)' },
  'Jamaica': { offset: 'UTC-5', label: 'UTC-5 (Jamaica Time)' },
  'Haiti': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Dominican Republic': { offset: 'UTC-4', label: 'UTC-4 (Atlantic Time)' },
  'Puerto Rico': { offset: 'UTC-4', label: 'UTC-4 (Atlantic Time)' },
  'Bahamas': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Trinidad and Tobago': { offset: 'UTC-4', label: 'UTC-4 (Atlantic Time)' },
  'Barbados': { offset: 'UTC-4', label: 'UTC-4 (Atlantic Time)' },
  'Aruba': { offset: 'UTC-4', label: 'UTC-4 (Atlantic Time)' },
  'Curaçao': { offset: 'UTC-4', label: 'UTC-4 (Atlantic Time)' },
  'Saint Lucia': { offset: 'UTC-4', label: 'UTC-4 (Atlantic Time)' },
  'Grenada': { offset: 'UTC-4', label: 'UTC-4 (Atlantic Time)' },

  // South America
  'Brazil': { offset: 'UTC-3', label: 'UTC-3 (Brasilia Time)' },
  'Argentina': { offset: 'UTC-3', label: 'UTC-3 (Argentina)' },
  'Chile': { offset: 'UTC-3', label: 'UTC-3 (Chile Time)' },
  'Peru': { offset: 'UTC-5', label: 'UTC-5 (Peru Time)' },
  'Colombia': { offset: 'UTC-5', label: 'UTC-5 (Colombia Time)' },
  'Venezuela': { offset: 'UTC-4', label: 'UTC-4 (Venezuela Time)' },
  'Ecuador': { offset: 'UTC-5', label: 'UTC-5 (Ecuador Time)' },
  'Bolivia': { offset: 'UTC-4', label: 'UTC-4 (Bolivia Time)' },
  'Paraguay': { offset: 'UTC-4', label: 'UTC-4 (Paraguay Time)' },
  'Uruguay': { offset: 'UTC-3', label: 'UTC-3 (Uruguay Time)' },
  'Guyana': { offset: 'UTC-4', label: 'UTC-4 (Guyana Time)' },
  'Suriname': { offset: 'UTC-3', label: 'UTC-3 (Suriname Time)' },
  'French Guiana': { offset: 'UTC-3', label: 'UTC-3 (French Guiana Time)' },
};

// Map specific cities to their timezones (for cities with different timezones than their country default)
const cityTimezones: Record<string, TimezoneInfo> = {
  // USA Cities (multiple timezones)
  'New York': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Los Angeles': { offset: 'UTC-8', label: 'UTC-8 (Pacific Time)' },
  'Chicago': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'Houston': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'Phoenix': { offset: 'UTC-7', label: 'UTC-7 (Mountain Time)' },
  'Philadelphia': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'San Antonio': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'San Diego': { offset: 'UTC-8', label: 'UTC-8 (Pacific Time)' },
  'Dallas': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'San Jose': { offset: 'UTC-8', label: 'UTC-8 (Pacific Time)' },
  'Austin': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },
  'San Francisco': { offset: 'UTC-8', label: 'UTC-8 (Pacific Time)' },
  'Seattle': { offset: 'UTC-8', label: 'UTC-8 (Pacific Time)' },
  'Denver': { offset: 'UTC-7', label: 'UTC-7 (Mountain Time)' },
  'Boston': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Miami': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Atlanta': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Las Vegas': { offset: 'UTC-8', label: 'UTC-8 (Pacific Time)' },
  'Portland': { offset: 'UTC-8', label: 'UTC-8 (Pacific Time)' },
  'Honolulu': { offset: 'UTC-10', label: 'UTC-10 (Hawaii)' },
  'Hawaii': { offset: 'UTC-10', label: 'UTC-10 (Hawaii)' },
  'Anchorage': { offset: 'UTC-9', label: 'UTC-9 (Alaska)' },
  'Alaska': { offset: 'UTC-9', label: 'UTC-9 (Alaska)' },

  // Canada Cities
  'Toronto': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Vancouver': { offset: 'UTC-8', label: 'UTC-8 (Pacific Time)' },
  'Montreal': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Calgary': { offset: 'UTC-7', label: 'UTC-7 (Mountain Time)' },
  'Edmonton': { offset: 'UTC-7', label: 'UTC-7 (Mountain Time)' },
  'Ottawa': { offset: 'UTC-5', label: 'UTC-5 (Eastern Time)' },
  'Winnipeg': { offset: 'UTC-6', label: 'UTC-6 (Central Time)' },

  // Australia Cities
  'Sydney': { offset: 'UTC+10', label: 'UTC+10 (Australia East)' },
  'Melbourne': { offset: 'UTC+10', label: 'UTC+10 (Australia East)' },
  'Brisbane': { offset: 'UTC+10', label: 'UTC+10 (Australia East)' },
  'Perth': { offset: 'UTC+8', label: 'UTC+8 (Australia West)' },
  'Adelaide': { offset: 'UTC+9:30', label: 'UTC+9:30 (Adelaide)' },
  'Darwin': { offset: 'UTC+9:30', label: 'UTC+9:30 (Darwin)' },
  'Hobart': { offset: 'UTC+10', label: 'UTC+10 (Australia East)' },

  // Indonesia Cities
  'Jakarta': { offset: 'UTC+7', label: 'UTC+7 (Western Indonesia)' },
  'Bali': { offset: 'UTC+8', label: 'UTC+8 (Central Indonesia)' },
  'Denpasar': { offset: 'UTC+8', label: 'UTC+8 (Central Indonesia)' },
  'Ubud': { offset: 'UTC+8', label: 'UTC+8 (Central Indonesia)' },

  // Russia Cities (multiple timezones)
  'Moscow': { offset: 'UTC+3', label: 'UTC+3 (Moscow)' },
  'Saint Petersburg': { offset: 'UTC+3', label: 'UTC+3 (Moscow)' },
  'Vladivostok': { offset: 'UTC+10', label: 'UTC+10 (Vladivostok)' },
  'Novosibirsk': { offset: 'UTC+7', label: 'UTC+7 (Novosibirsk)' },
  'Yekaterinburg': { offset: 'UTC+5', label: 'UTC+5 (Yekaterinburg)' },

  // Brazil Cities
  'São Paulo': { offset: 'UTC-3', label: 'UTC-3 (Brasilia Time)' },
  'Rio de Janeiro': { offset: 'UTC-3', label: 'UTC-3 (Brasilia Time)' },
  'Manaus': { offset: 'UTC-4', label: 'UTC-4 (Amazon Time)' },

  // China Cities (all same timezone despite size)
  'Beijing': { offset: 'UTC+8', label: 'UTC+8 (China Standard Time)' },
  'Shanghai': { offset: 'UTC+8', label: 'UTC+8 (China Standard Time)' },
  'Shenzhen': { offset: 'UTC+8', label: 'UTC+8 (China Standard Time)' },
  'Guangzhou': { offset: 'UTC+8', label: 'UTC+8 (China Standard Time)' },
  'Chengdu': { offset: 'UTC+8', label: 'UTC+8 (China Standard Time)' },
  'Xi\'an': { offset: 'UTC+8', label: 'UTC+8 (China Standard Time)' },

  // Japan Cities
  'Tokyo': { offset: 'UTC+9', label: 'UTC+9 (Japan Standard Time)' },
  'Osaka': { offset: 'UTC+9', label: 'UTC+9 (Japan Standard Time)' },
  'Kyoto': { offset: 'UTC+9', label: 'UTC+9 (Japan Standard Time)' },
  'Hiroshima': { offset: 'UTC+9', label: 'UTC+9 (Japan Standard Time)' },
  'Fukuoka': { offset: 'UTC+9', label: 'UTC+9 (Japan Standard Time)' },
  'Sapporo': { offset: 'UTC+9', label: 'UTC+9 (Japan Standard Time)' },
  'Nagoya': { offset: 'UTC+9', label: 'UTC+9 (Japan Standard Time)' },

  // Key European Cities
  'London': { offset: 'UTC+0', label: 'UTC+0 (London, Dublin)' },
  'Paris': { offset: 'UTC+1', label: 'UTC+1 (Paris, Berlin, Rome)' },
  'Berlin': { offset: 'UTC+1', label: 'UTC+1 (Paris, Berlin, Rome)' },
  'Rome': { offset: 'UTC+1', label: 'UTC+1 (Paris, Berlin, Rome)' },
  'Madrid': { offset: 'UTC+1', label: 'UTC+1 (Madrid)' },
  'Barcelona': { offset: 'UTC+1', label: 'UTC+1 (Barcelona)' },
  'Amsterdam': { offset: 'UTC+1', label: 'UTC+1 (Amsterdam)' },
  'Vienna': { offset: 'UTC+1', label: 'UTC+1 (Vienna)' },
  'Prague': { offset: 'UTC+1', label: 'UTC+1 (Prague)' },
  'Budapest': { offset: 'UTC+1', label: 'UTC+1 (Budapest)' },
  'Warsaw': { offset: 'UTC+1', label: 'UTC+1 (Warsaw)' },
  'Athens': { offset: 'UTC+2', label: 'UTC+2 (Athens)' },
  'Istanbul': { offset: 'UTC+3', label: 'UTC+3 (Istanbul)' },
  'Dublin': { offset: 'UTC+0', label: 'UTC+0 (London, Dublin)' },
  'Lisbon': { offset: 'UTC+0', label: 'UTC+0 (Lisbon)' },
  'Brussels': { offset: 'UTC+1', label: 'UTC+1 (Brussels)' },
  'Zurich': { offset: 'UTC+1', label: 'UTC+1 (Zurich)' },
  'Munich': { offset: 'UTC+1', label: 'UTC+1 (Munich)' },
  'Frankfurt': { offset: 'UTC+1', label: 'UTC+1 (Frankfurt)' },
  'Milan': { offset: 'UTC+1', label: 'UTC+1 (Milan)' },
  'Venice': { offset: 'UTC+1', label: 'UTC+1 (Venice)' },
  'Florence': { offset: 'UTC+1', label: 'UTC+1 (Florence)' },
  'Copenhagen': { offset: 'UTC+1', label: 'UTC+1 (Copenhagen)' },
  'Stockholm': { offset: 'UTC+1', label: 'UTC+1 (Stockholm)' },
  'Oslo': { offset: 'UTC+1', label: 'UTC+1 (Oslo)' },
  'Helsinki': { offset: 'UTC+2', label: 'UTC+2 (Helsinki)' },

  // Key Asian Cities
  'Bangkok': { offset: 'UTC+7', label: 'UTC+7 (Bangkok)' },
  'Ho Chi Minh City': { offset: 'UTC+7', label: 'UTC+7 (Ho Chi Minh)' },
  'Hanoi': { offset: 'UTC+7', label: 'UTC+7 (Hanoi)' },
  'Singapore': { offset: 'UTC+8', label: 'UTC+8 (Singapore)' },
  'Kuala Lumpur': { offset: 'UTC+8', label: 'UTC+8 (Kuala Lumpur)' },
  'Manila': { offset: 'UTC+8', label: 'UTC+8 (Manila)' },
  'Hong Kong': { offset: 'UTC+8', label: 'UTC+8 (Hong Kong)' },
  'Taipei': { offset: 'UTC+8', label: 'UTC+8 (Taipei)' },
  'Seoul': { offset: 'UTC+9', label: 'UTC+9 (Seoul)' },
  'Mumbai': { offset: 'UTC+5:30', label: 'UTC+5:30 (India)' },
  'Delhi': { offset: 'UTC+5:30', label: 'UTC+5:30 (India)' },
  'New Delhi': { offset: 'UTC+5:30', label: 'UTC+5:30 (India)' },
  'Bangalore': { offset: 'UTC+5:30', label: 'UTC+5:30 (India)' },
  'Kolkata': { offset: 'UTC+5:30', label: 'UTC+5:30 (India)' },
  'Dubai': { offset: 'UTC+4', label: 'UTC+4 (Dubai)' },
  'Abu Dhabi': { offset: 'UTC+4', label: 'UTC+4 (Abu Dhabi)' },
  'Doha': { offset: 'UTC+3', label: 'UTC+3 (Doha)' },

  // Key African Cities
  'Cairo': { offset: 'UTC+2', label: 'UTC+2 (Cairo)' },
  'Cape Town': { offset: 'UTC+2', label: 'UTC+2 (South Africa)' },
  'Johannesburg': { offset: 'UTC+2', label: 'UTC+2 (South Africa)' },
  'Marrakech': { offset: 'UTC+1', label: 'UTC+1 (Morocco)' },
  'Casablanca': { offset: 'UTC+1', label: 'UTC+1 (Morocco)' },
  'Nairobi': { offset: 'UTC+3', label: 'UTC+3 (Nairobi)' },
  'Lagos': { offset: 'UTC+1', label: 'UTC+1 (Lagos)' },
  'Accra': { offset: 'UTC+0', label: 'UTC+0 (Accra)' },

  // South American Cities
  'Buenos Aires': { offset: 'UTC-3', label: 'UTC-3 (Buenos Aires)' },
  'Lima': { offset: 'UTC-5', label: 'UTC-5 (Lima)' },
  'Bogotá': { offset: 'UTC-5', label: 'UTC-5 (Bogota)' },
  'Bogota': { offset: 'UTC-5', label: 'UTC-5 (Bogota)' },
  'Santiago': { offset: 'UTC-3', label: 'UTC-3 (Santiago)' },
  'Cusco': { offset: 'UTC-5', label: 'UTC-5 (Cusco)' },
  'Cartagena': { offset: 'UTC-5', label: 'UTC-5 (Cartagena)' },
  'Medellín': { offset: 'UTC-5', label: 'UTC-5 (Medellin)' },
  'Quito': { offset: 'UTC-5', label: 'UTC-5 (Quito)' },

  // Oceania Cities
  'Auckland': { offset: 'UTC+12', label: 'UTC+12 (Auckland)' },
  'Wellington': { offset: 'UTC+12', label: 'UTC+12 (Wellington)' },
  'Queenstown': { offset: 'UTC+12', label: 'UTC+12 (Queenstown)' },
  'Fiji': { offset: 'UTC+12', label: 'UTC+12 (Fiji)' },
  'Suva': { offset: 'UTC+12', label: 'UTC+12 (Fiji)' },
};

/**
 * Get timezone information for a destination (city, country format)
 * @param destination - The destination string, e.g., "Tokyo, Japan" or "Paris, France"
 * @returns TimezoneInfo object with offset and label, or null if not found
 */
export function getTimezoneForDestination(destination: string): TimezoneInfo | null {
  if (!destination) return null;

  // Parse destination - handle formats like "Tokyo, Japan" or "Paris"
  const parts = destination.split(',').map(p => p.trim());
  const city = parts[0];
  const country = parts[1] || '';

  // First try city-specific timezone (more accurate for cities in large countries)
  if (cityTimezones[city]) {
    return cityTimezones[city];
  }

  // Try country timezone
  if (country && countryTimezones[country]) {
    return countryTimezones[country];
  }

  // Try matching city name to country name (some locations only have city)
  if (countryTimezones[city]) {
    return countryTimezones[city];
  }

  // Fallback: try partial matches for country names
  const lowerCountry = country.toLowerCase();
  for (const [key, value] of Object.entries(countryTimezones)) {
    if (key.toLowerCase() === lowerCountry || key.toLowerCase().includes(lowerCountry)) {
      return value;
    }
  }

  return null;
}

/**
 * Get a list of common timezones for dropdown selection
 */
export function getTimezonesList(): string[] {
  return [
    'UTC-12 (Baker Island)',
    'UTC-11 (Samoa)',
    'UTC-10 (Hawaii)',
    'UTC-9 (Alaska)',
    'UTC-8 (Pacific Time)',
    'UTC-7 (Mountain Time)',
    'UTC-6 (Central Time)',
    'UTC-5 (Eastern Time)',
    'UTC-4 (Atlantic Time)',
    'UTC-3 (Argentina)',
    'UTC-2 (Mid-Atlantic)',
    'UTC-1 (Azores)',
    'UTC+0 (London, Dublin)',
    'UTC+1 (Paris, Berlin, Rome)',
    'UTC+2 (Cairo, Athens)',
    'UTC+3 (Moscow, Istanbul)',
    'UTC+4 (Dubai, Baku)',
    'UTC+5 (Pakistan, Uzbekistan)',
    'UTC+5:30 (India, Sri Lanka)',
    'UTC+6 (Bangladesh, Kazakhstan)',
    'UTC+7 (Thailand, Vietnam)',
    'UTC+8 (China, Singapore, Malaysia)',
    'UTC+9 (Japan, South Korea)',
    'UTC+10 (Australia East)',
    'UTC+11 (Solomon Islands)',
    'UTC+12 (New Zealand)',
  ];
}
